<template>
  <div class="mw-split-right">
    <div style="width: 100%;height: 100%;">
      <div class="mw-toolbar">
        <el-button @click="changeFormData">修改字段</el-button>
        <el-button @click="editAuthority">修改读作者域</el-button>
        <el-button @click="changeComment">修改意见</el-button>
        <el-button @click="complete">强制办毕</el-button>
        <el-button @click="replaceTaskIdentity">转换办理人</el-button>
        <!-- <el-button>修改附件</el-button> -->
        <el-button @click="terminate">强制办结</el-button>
        <el-button @click="killTask">作废</el-button>
        <!--<el-button @click="doRecycle">恢复</el-button>-->
        <el-dropdown @command="handleCommand">
          <el-button>
            节点跳转<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jump2normalFlow">普通流向</el-dropdown-item>
            <el-dropdown-item command="jump2concurrenceFlow">并行发送</el-dropdown-item>
            <el-dropdown-item command="jump2multipleInstanceFlow">多实例发送</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button @click="forceWithdraw">强制回收</el-button>
        <el-button @click="editAttachment">编辑正文/附件</el-button>
        <!--<el-button @click="deleteDocument">彻底删除</el-button>-->
      </div>
      <div
        class="mw-toolbar__body mw-app__edit"
        style=""
      >
        <div class="mw-pagination__body">
          <el-table
            stripe
            border
            height="100%"
            class='mw-table'
            :data="dataList"
            @selection-change="handleSelectionChange"
            style="width: 100%"
          >
            <el-table-column
              type="selection"
              width="40"
            />
            <el-table-column label="文件标题">
              <template slot-scope="scope">
                <a
                  href="#"
                  @click.prevent="openForm(scope.row)"
                >{{ scope.row.businessName }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="processDefinitionName"
              label="所属流程"
              width="120"
            />
            <el-table-column
              prop="currentTaskName"
              label="当前环节"
              width="120"
            />
            <el-table-column
              prop="currentTransactor"
              label="当前办理人"
              width="120"
            />
            <el-table-column
              prop="startTime"
              label="创建时间"
              width="170"
            />
            <el-table-column
              prop="startUserName"
              label="创建人"
              width="120"
            />
            <el-table-column
              label="当前状态"
              width="100"
            >
              <template slot-scope="scope">
                {{scope.row.suspensionState === '2' ? '已挂起' : ["正在办理", "已办结"][scope.row.flowStatus]}}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="mw-pagination">
          <simple-pagination
            v-model="pagination"
            @input="updateTable"
          />
        </div>
      </div>
    </div>
    <ChangeFormData
      ref="changeFormDataRef"
      @updateTable="updateTable"
    />
    <ChangeComment ref="changeComment" />
    <Complete
      ref="complete"
      @updateTable="updateTable"
    />
    <ReplaceTaskIdentity
      ref="replaceTaskIdentity"
      @updateTable="updateTable"
    />
    <ForceWithdraw
      ref="forceWithdraw"
      @updateTable="updateTable"
    />
    <EditAttachment
      ref="editAttachment"
      @updateTable="updateTable"
    />
    <Jump2normalFlow
      ref="jump2normalFlow"
      @updateTable="updateTable"
    />
    <Jump2concurrenceFlow
      ref="jump2concurrenceFlow"
      @updateTable="updateTable"
    />
    <Jump2multipleInstanceFlow
      ref="jump2multipleInstanceFlow"
      @updateTable="updateTable"
    />
    <edit-authority
      ref="editAuthority"
      @updateTable="updateTable"
    />
    <Recycle
      ref="recycle"
      @updateTable="updateTable"
    />
  </div>
</template>

<script>

  import api from "@/common/api/maintain";
  import SimplePagination from "./common/simplePagination.vue";
  import ChangeFormData from "./actions/changeFormData.vue";
  import ChangeComment from "./actions/changeComment.vue";
  import Complete from "./actions/complete.vue";
  import ReplaceTaskIdentity from "./actions/replaceTaskIdentity.vue";
  import ForceWithdraw from "./actions/forceWithdraw.vue";
  import EditAttachment from './actions/editAttachment.vue';
  import Jump2normalFlow from "./actions/jump2normalFlow.vue";
  import Jump2concurrenceFlow from "./actions/jump2concurrenceFlow.vue";
  import Jump2multipleInstanceFlow from "./actions/jump2multipleInstanceFlow.vue";
  import EditAuthority from "./actions/editAuthority.vue";
  import Recycle from "./actions/recycle.vue";

    export default {
      name: 'mw-flow-interfering-table',
      data() {
        return {
          dataList: [],
          pagination: {
            total: 0,
            start: 0,
            limit: 10
          },
        }
      },
      props: {
        filterParams:{
          type: Object,
          default: function () {
            return {};
          }
        }
      },
      watch: {
        filterParams(val) {
          this.filterParams = val;
          if(!_.isEmpty(val))
            this.updateTable();
        }
      },
      mounted() {
        if(this.filterParams.businessId || this.filterParams.businessName){
          this.updateTable();
        }
      },
      methods: {
        async updateTable() {
            if (!this.filterParams.businessName && !this.filterParams.businessId) {
              this.mwMsg("warning", "标题或业务ID不能为空!");
              return;
            }
            const { result, success, totalCount } = await api.listFlowDocument({
              isFlow: true,
              year: this.filterParams.year || undefined,
              processDefinitionName:
                (this.filterParams.processDefinition || {}).name || undefined,
              draftsUnitId: this.filterParams.matchDept
                ? undefined
                : (this.filterParams.draftsUnit || {}).id || undefined,
              draftsDeptId: this.filterParams.matchDept
                ? (this.filterParams.draftsUnit || {}).id || undefined
                : undefined,
              businessNameLike: this.filterParams.businessName || undefined,
              businessId: this.filterParams.businessId || undefined,
              flowStatus:
                this.filterParams.flowStatus === "2"
                  ? undefined
                  : this.filterParams.flowStatus || undefined,
              suspensionState:
                this.filterParams.flowStatus === "2"
                  ? "2"
                  : this.filterParams.flowStatus === "1" ||
                  this.filterParams.flowStatus === "0"
                  ? "1"
                  : undefined,
              start: this.pagination.start || undefined,
              limit: this.pagination.limit || undefined,
              orderBy: this.orderBy || undefined
            });
            this.pagination = {
              ...this.pagination,
              total: parseInt(totalCount, 10)
            };
            this.dataList = result;
        },
        openForm(data) {
          const {
            id: formId,
            applicationId: appId,
            businessId,
            batchId,
            draftsDocId,
            processDefinitionId,
            moduleId
          } = data;
          PF.show(
            "flowForm",
            {
              businessId,
              batchId,
              draftsDocId,
              moduleId,
              appId,
              processDefinitionId,
              editMode: false,
              size: "large_large",
              formOpenSource: "pc:flow-interfering.table"
            },
            () => {},
            () => {}
          );
        },
        handleSelectionChange(selection) {
          this.selection = selection;
        },
        changeFormData() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          this.mwRef("changeFormDataRef").action(this.selection[0]);
        },
        changeComment() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          this.mwRef("changeComment").action(this.selection[0]);
        },
        async doRecycle(){
          if (this.selection.length < 1) {
            this.mwMsg("warning", "请至少选择一条记录。");
            return;
          }
          let _selection=this.selection.filter(x => { return x.suspensionState=="2"})
          if(_selection.length<1){
            this.mwMsg("warning", "请选择挂起状态的流程记录！");
            return;
          }
          const {success} = await api.activeDocument(_selection.map(x => x.batchId), {});
          if (success) {
            this.mwMsg('恢复成功');
            this.updateTable();
          }
        },
        complete() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          this.mwRef("complete").action(this.selection[0]);
        },
        replaceTaskIdentity() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          this.mwRef("replaceTaskIdentity").action(this.selection[0]);
        },
        async terminate() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          if (await this.mwConfirm("您确定将此文件强制办结吗？请谨慎操作！")) {
            const { batchId } = this.selection[0];
            if ((await api.terminateProcess(batchId, "强制办结", {})).success) {
              this.mwMsg("操作成功.");
              this.updateTable();
            }
          }
        },
        async killTask() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", $lang("请选择一份文件"));
            return;
          }
          if (await this.mwConfirm($lang("您确定将此文件作废吗？请谨慎操作！"))) {
            const { batchId } = this.selection[0];
            if ((await api.suspendProcess(batchId, "",{})).success) {
              this.mwMsg($lang("操作成功"));
              this.updateTable();
            }
          }
        },
        async forceWithdraw() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }

          this.mwRef("forceWithdraw").action(this.selection[0]);
        },
        editAttachment() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          this.mwRef("editAttachment").action(this.selection[0]);
          this.mwRef("editAttachment").mwRef("dialog").show();
        },
        handleCommand(cmd) {
          this[cmd]();
        },
        jump2normalFlow() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          this.mwRef("jump2normalFlow").action(this.selection[0]);
        },
        jump2concurrenceFlow() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          this.mwRef("jump2concurrenceFlow").action(this.selection[0]);
        },
        jump2multipleInstanceFlow() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          this.mwRef("jump2multipleInstanceFlow").action(this.selection[0]);
        },
        editAuthority() {
          if (this.selection.length !== 1) {
            this.mwMsg("warning", "请选择一份文件。");
            return;
          }
          this.mwRef("editAuthority").action(this.selection[0]);
        }
      },
      components: {


        SimplePagination,

        ChangeFormData,
        ChangeComment,
        Complete,

        ReplaceTaskIdentity,

        ForceWithdraw,
        EditAttachment,
        Jump2normalFlow,
        Jump2concurrenceFlow,
        Jump2multipleInstanceFlow,
        EditAuthority,
        Recycle
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/rightPanel.vue